import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Seo from "@/components/Seo";

export default function TrackOrder() {
  const [id, setId] = useState("");
  const nav = useNavigate();
  return (
    <div className="mx-auto max-w-lg px-4 py-16 text-center">
      <Seo
        title="Track Your Order"
        description="Track your YourPlants.in plant order status by order ID, from nursery dispatch to doorstep delivery."
        path="/track"
      />
      <div className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">Order tracking</div>
      <h1 className="font-serif-display text-3xl text-[var(--yp-primary)] mt-2">Track your order</h1>
      <p className="text-[var(--yp-muted)] mt-2 text-sm">Enter your order ID (starts with GS)</p>
      <form onSubmit={(e) => { e.preventDefault(); if (id.trim()) nav(`/order/${id.trim()}`); }} className="mt-6 flex gap-2">
        <input data-testid="track-input" value={id} onChange={(e) => setId(e.target.value)} placeholder="GS1A2B3C4D" className="flex-1 border border-[var(--yp-border)] rounded-full px-4 py-3 text-sm outline-none focus:border-[var(--yp-primary)]" />
        <button data-testid="track-submit" className="btn-primary rounded-full px-6 text-sm font-medium">Track</button>
      </form>
      <div className="mt-6 text-xs text-[var(--yp-muted)]"><Link to="/site-visit" className="underline">Track a site visit</Link> instead</div>
    </div>
  );
}
